export interface VersionInfo {
  version: string;
  timestamp: number;
}

export const VERSION: VersionInfo = {
  version: require('../../../../package.json').version,  // Điều chỉnh đường dẫn tới package.json
  timestamp: new Date().getTime()
};
